import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { SharedModalService } from './../shared-modal.service';
import { SharedHelperService } from './../shared-helper.service';
import { SharedService } from './../../shared/shared.service';
import { BusinessService } from './../../pages/business/business.service';
import { AuthServiceZ } from './../../authentification/auth-service.service';

declare var $;

@Component({
  selector: 'app-packaging-html-to-pdf',
  templateUrl: './packaging-html-to-pdf.component.html',
  styleUrls: ['./packaging-html-to-pdf.component.scss'],
})
export class PackagingHtmlToPdfComponent implements OnChanges {
  @Input() deliveryRequest = null;
  @Input() nid = null;
  @Input() _packingSlip = null;
  packingSlip;
  qrwidth = 128;
  constructor(
    private sharedModalService: SharedModalService,
    private sharedHelperService: SharedHelperService,
    private authService: AuthServiceZ,
  ) {}

  ngOnChanges() {
    if (this.isMobile()) {
      this.qrwidth = 85;
    }

    console.log('this._packingSlip:', this._packingSlip);

    if (this._packingSlip) {
      this.packingSlip = this._packingSlip;
      return;
    }
    this.getAllTherequests();
  }

  getAllTherequests() {
    const query = {
      populate: [
        { path: 'dropOffjobRequest' },
        {
          path: 'pickUpjobRequest',
          populate: [{ path: 'business pickUp' }],
        },
      ],
    };

    const params = this.sharedHelperService.convertObjectToParams(query);

    this.sharedModalService.getPackingSlip(this.nid, params).then((d) => {
      this.packingSlip = d;
    });
  }

  isMobile() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }
}
